module.exports = __webpack_public_path__ + "static/media/house-flood.d1ac0d5d.svg";